export default __webpack_public_path__ + "static/emails-73fedac889f31c226d7b7161239a1e84.svg";